/**
 * Structured Job within a service order.
 */
import { CostLimit } from './cost-limit';
import { ServiceOrderComment } from './service-order-comment';
import { ServicePackage } from '../common/service-package';
import { DmsFlatRateUnit } from '../common/dms-flat-rate-unit';
import { DmsPart } from '../common/dms-part';
import { DmsSublet } from '../common/dms-sublet';
import { TextPosition } from './text-position';

export class ServiceOrderJob {
  /** True if a cost estimate for this job has been required by the customer. */
  costEstimateRequired?: boolean;

  /** Cost approval granted by the customer for this job (if available). */
  costLimit?: CostLimit;

  /** List of flat rate units. */
  flatRateUnitList?: DmsFlatRateUnit[];

  /** 128-bit globally unique identifier that uniquely identifies the job. */
  externalId?: string;

  /** Job comment for rough planning. */
  jobComment?: ServiceOrderComment;

  /** Job description. Careful, customer will see this text! */
  jobDescription: string;

  /** "O-Ton" customer. */
  originalStatementCustomer?: string;

  /** List of packages. */
  packageList?: ServicePackage[];

  /** List of parts. */
  partList?: DmsPart[];

  /** True if the customer repeatedly reports the same issue. */
  repeatedRepair?: boolean;

  /** List of sublets. */
  subletList?: DmsSublet[];

  /** List of text positions on this job. Only for internal purposes! */
  textPositionList?: TextPosition[];

  /** True if the customer's vehicle was towed to the workshop and may not leave without repair. */
  towedInVehicle?: boolean;
}
